export default __webpack_public_path__ + "static/media/chillTechTabloidDark.95c10d2e.png";